var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDashDiagonalLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  rx: 22,
  fill: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.0001 30C24.1219 30 26.1567 29.1571 27.657 27.6569C29.1573 26.1566 30.0001 24.1217 30.0001 22",
  stroke: "white",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.0001 13.9995C19.8784 13.9995 17.8436 14.8424 16.3433 16.3427C14.843 17.8429 14.0001 19.8778 14.0001 21.9995",
  stroke: "white",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 14.0452,
  y: 28.187,
  width: 20,
  height: 2.5,
  rx: 1.25,
  transform: "rotate(-45 14.0452 28.187)",
  fill: "white"
})));
export default SvgDashDiagonalLarge;